var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemoveImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 32 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_167_1052)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_167_1052)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18.0001,
    cy: 13.9995,
    r: 10,
    transform: "rotate(90 18.0001 13.9995)",
    fill: "#161617"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.0001,
    cy: 13.9995,
    r: 10.4078,
    transform: "rotate(90 18.0001 13.9995)",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 0.815502
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.1121 10.0623L14.9733 18.9934C15.0136 19.4115 15.365 19.7306 15.785 19.7306H20.5729C20.9929 19.7306 21.3443 19.4115 21.3846 18.9934L22.2458 10.0623M12.6608 10.0623H23.4844",
    stroke: "white",
    strokeWidth: 0.815502,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4037 9.4445L16.4037 8.16114C16.4037 7.93595 16.5862 7.75339 16.8114 7.75339H19.5245C19.7497 7.75339 19.9322 7.93595 19.9322 8.16114V9.08021",
    stroke: "white",
    strokeWidth: 0.815502,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_167_1052",
    x: 0.930028,
    y: 0.191546,
    width: 34.1402,
    height: 34.1399,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.26201
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.12727
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_167_1052"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_167_1052",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_167_1052",
    x: 0.660558,
    y: -3.33993,
    width: 34.6791,
    height: 34.6789,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3.26201
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_167_1052"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_167_1052",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveImage);
export default __webpack_public_path__ + "static/media/removeImage.54ac88e7b8734fcf52869faa3e4c4908.svg";
export { ForwardRef as ReactComponent };